import {
  FullAlertResponse,
  ShortAlertResponse,
} from 'app/modules/alerts/types/responses';
import {
  FullCaseResponse,
  ShortCaseResponse,
} from 'app/modules/cases/responses';

export interface InvestigationsAlertResponse<Short extends boolean = true> {
  alerts: Short extends true ? ShortAlertResponse[] : FullAlertResponse[];
  count: number;
  data_loader?: DataLoaderState<'ALERT'>;
}

export enum DataLoaderStatus {
  NOT_STARTED = 'NOT_STARTED',
  TO_QUEUE = 'TO_QUEUE',
  QUEUED = 'QUEUED',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  SKIPPED = 'SKIPPED', // requested recently and skipped
}

export type DataLoaderJobType =
  | 'txn_event'
  | 'instrument'
  | 'action_event'
  | 'entity'
  | 'entity_txn_event_assoc'
  | 'instrument_txn_event_assoc';

export interface DataLoaderJobState {
  status: DataLoaderStatus;
  seconds_since_execution: number | null;
}

// This allows us to determine which articles have outdated cache data and when was the last time that the cache job was executed so we can show the right loading state
export interface DataLoaderState<T extends 'ALERT' | 'CASE' | 'SAR_FILING'> {
  article_type: T;
  article_ids: {
    [id: number]: {
      [jobType in DataLoaderJobType]: DataLoaderJobState;
    };
  };
}

export interface InvestigationsCaseResponse<Short extends boolean = true> {
  cases: Short extends true ? ShortCaseResponse[] : FullCaseResponse[];
  count: number;
}

export type InvestigationsActionResponse =
  | InvestigationsAlertResponse
  | InvestigationsCaseResponse;

export interface InvestigationsAgentStatsResponse {
  open_count: number;
  completed_last_24_hrs_count: number;
  fetched_at: string;
}

export interface CGDOLoadingResponse {
  data_loader: {
    [hashed_id: string]: DataLoaderJobState;
  };
}

export interface CachedInvestigationsCaseResponse<
  Short extends boolean = true,
> extends InvestigationsCaseResponse<Short> {
  data_loader: DataLoaderState<'CASE'>;
}
